export default __webpack_public_path__ + "static/media/imgPrize1.39a3122d.png";